<template>
  <table class="table" v-if="customer.first_name">
    <tbody>
      <tr>
        <td>Agency</td>
        <th scope="row">{{ customer.agency[0].name }}</th>
      </tr>
      <tr>
        <td>Company</td>
        <th scope="row">{{ customer.company }}</th>
      </tr>
      <tr>
        <td>Name</td>
        <th scope="row">{{ customer.title }} {{ customer.first_name }} {{ customer.middle_name }} {{ customer.last_name }}</th>
      </tr>
      <tr>
        <td>Address</td>
        <th scope="row">{{ customer.address_1 }} <div v-if="customer.address_2">{{ customer.address_2 }}</div></th>
      </tr>
      <tr>
        <td>ZIP</td>
        <th scope="row">{{ customer.postal_code }}</th>
      </tr>
      <tr>
        <td>City</td>
        <th scope="row">{{ customer.city }}</th>
      </tr>
      <tr>
        <td>Country</td>
        <th scope="row">{{ getCountry(customer.country)[0].name }}</th>
      </tr>
      <tr>
        <td>State</td>
        <th scope="row">{{ customer.state }}</th>
      </tr>
      <tr>
        <td>E-mail address</td>
        <th scope="row">{{ customer.email }}</th>
      </tr>
      <tr>
        <td>Website</td>
        <th scope="row">{{ customer.website }}</th>
      </tr>
      <tr>
        <td>Phone</td>
        <th scope="row">{{ customer.phone }}</th>
      </tr>
      <tr>
        <td>Cellphone</td>
        <th scope="row">{{ customer.cell_phone }}</th>
      </tr>
    </tbody>
  </table>
</template>

<script>
import Country from '@/Shared/Country.js'

export default {
  name: 'CustomerData',
  props: ['customer'],
  data() {
    return {
      countries: Country
    }
  },
  methods: {
    getCountry(country) {
      return this.countries.filter(c => c.code == country)
    }
  }
}
</script>

<style>

</style>
